<template>
  <div>
    <b-modal
      :id="modalID"
      size="xl"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      header-class="card-header-padding"
      dialog-class="fullscreen-modal card-header-padding"
      style="max-width: 100%; margin: 0; top: 0; bottom: 0; left: 0; right: 0; height: 100vh; display: flex;">
      <template v-slot:modal-header="{ close }" style="padding: 0 !important">
        <b-dropdown class="pull-right" size="sm" v-model="chartType" @change="switchChart()" variant="default" no-caret="">
          <template v-slot:button-content>
            <b-icon icon="bar-chart-fill" font-scale="2"></b-icon>
          </template>
          <b-dropdown-item v-for="item in supportedCharts" :key="item.label" @click="switchChart()" v-bind:value="item.value">{{ item.label }}</b-dropdown-item>
        </b-dropdown>
        <b-button size="sm" class="pull-right" variant="default" @click="close()">
          <b-icon icon="x-circle" font-scale="2"></b-icon>
        </b-button>
      </template>
      <growth-chart
          :data="values"
          :value-title="`${title} Count`"
          :title="title"
          :hide-aggregation="true"
          :no-title-suffix="true"
        />
    </b-modal>

    <div
      v-masonry-tile
      v-if="hasData"
      :class="`insight d-inline-block insight-cols-${this.widthColumns}`"
      style="vertical-align: top; padding: 0 !important; margin: 0 !important; position: relative !important">
      <b-card
        header-tag="header"
        header-class="card-header-padding"
        class="card-style">
        <template v-slot:header style="padding: 0 !important">
          <b-dropdown class="pull-right" size="sm" v-model="chartType" @change="switchChart()" variant="default" no-caret="">
            <template v-slot:button-content>
              <b-icon icon="bar-chart-fill"></b-icon>
            </template>
            <b-dropdown-item v-for="item in supportedCharts" :key="item.label" @click="switchChart()" v-bind:value="item.value">{{ item.label }}</b-dropdown-item>
          </b-dropdown>
          <p class="h4">
            <!-- <strong class="ml-3" style="font-size: 14px">{{ chartHeading }}</strong> -->
            <b-button variant="default" v-b-modal="modalID" class="pull-right">
              <b-icon icon="arrows-fullscreen"></b-icon>
            </b-button>
            <b-button variant="default" v-b-toggle="`collapse-chart-${collapseID}`" class="m-1 pull-right"
              @click="toggleChart()">
              <b-icon icon="arrow-up-circle"></b-icon>
            </b-button>
          </p>
        </template>
        <b-collapse visible :id="`collapse-chart-${collapseID}`">
          <growth-chart
            :data="values"
            :value-title="`${title} Count`"
            :title="title"
            :hide-aggregation="true"
            :no-title-suffix="true"
          />
        </b-collapse>
        <!-- <chart :options="chartOptions" style="height: 100%; position: relative;" /> -->
      </b-card>
    </div>
  </div>
  <!-- <categorical-insight-container :columns="2" v-if="data">
    <growth-chart
      :data="data"
      :value-title="`${dataFileType} Count`"
      :title="title"
      :hide-aggregation="true"
      :no-title-suffix="true"
    />
  </categorical-insight-container> -->
</template>

<script>
  import GrowthChart from './GrowthChart';
  import {Chart} from 'highcharts-vue';
  import HighChartsDrillDown from 'highcharts/modules/drilldown'
  import {maybeMissingValueLabel, lowerCase, titleCase} from './utils';
  import {CATEGORICAL_INSIGHT_HEIGHT} from './utils';
  import Highcharts from 'highcharts'
  import loadDrillDown from 'highcharts/modules/drilldown'
  loadDrillDown(Highcharts)

  export default {
    name: 'DateInsight',

    components: {
      GrowthChart
    },

    props: {
      isString: Boolean,
      isArray: Boolean,
      isObject: Boolean,
      name: {
        type: String,
        default: "Count"
      },
      xlabel: String,
      xlabeltype: String,
      ylabel: String,
      defaultChart: String,
      drilldown: Boolean,
      subtitle: String,
      
      values: Object,
      dataFileType: String
    },

    data() {
      return {
        selectedItem: "",
        chartType: "",
        chartTitle: "",
        chartHeight: "100%",
        chartData: [],
        exportOptions: {}
      }
    },

    methods: {
      checkIfObject(x) {
        if ((typeof x === "object" || typeof x === 'function') && (x !== null)) {
          return true;
        }
        return false;
      },

      redrawChart() {
        console.log("Selected field: ", this.selectedItem);
        this.chartTitle = this.name + " - " + this.selectedItem;
        this.chartData = this.values[this.selectedItem];
        return this.chartOptions;
      },

      switchChart() {
        console.log('switch', event.target.text);
        this.chartType = event.target.text;
        if (this.chartType === 'line') this.chartType = 'spline';
        if (this.chartType === 'area') this.chartType = 'areaspline';
        if (this.chartType === 'pie') console.log("Data: ", this.chartData);
        return this.chartOptions;
      },

      toggleChart() {
        if (this.chartHeight === "100%") {
          this.chartHeight = "5%";
        } else {
          this.chartHeight = "100%";
        }
      },

      defaultExportOptions() {
        return {
          buttons: {
            contextButton: {
              menuItems: [
                'printChart',
                'separator',
                'downloadPNG',
                'downloadJPEG',
                'downloadPDF',
                'downloadSVG'
              ]
            }
          }
        };
      }
    },

    computed: {
      title() {
        return titleCase(this.name);
      },

      hasData() {
        return this.values; // && this.values.length > 1;
      },

      getHeight() {
        return this.chartHeight;
      },

      chartHeading() {
        return titleCase(this.name);
      },

      collapseID() {
        return this.name.toLowerCase().replace(" ", "-");
      },

      modalID() {
        return "modal-" + this.name;
      },

      innerStyle() {
        const spacing = "20px 4px";
        return {
          height: `${CATEGORICAL_INSIGHT_HEIGHT}px`,
          width: `calc(100% - ${spacing} * 2)`,
          margin: spacing,
          position: "relative"
        };
      },

      selectOptions() {
        return Object.keys(this.value);
      },

      supportedCharts() {
        return [
          {label: 'bar', value: 'bar'},
          {label: 'column', value: 'column'},
          {label: 'line', value: 'spline'},
          {label: 'area', value: 'areaspline'},
          {label: 'pie', value: 'pie'}
          ];
      },

      widthColumns() {
        return (!!this.width) ? this.width : (this.values.length >= 2 && this.isString) || this.isObject || this.isArray ? 1 : 1;
      },

      chartOptions() {
        this.chartData = (!!this.selectedItem) ? this.chartData : this.values;
        console.log("chart options", this.xlabeltype, this.name, this.isObject, this.isArray, this.chartData);
        if (!this.hasData) {
          return {};
        }
        else {
          this.exporting = (!!this.exportOptions && this.exportOptions.length > 0) ? this.exportOptions : this.defaultExportOptions();
          if (this.drilldown && this.subtitle) {
            console.log("drilldown", this.chartData);
            return this.drillDownChartOptions;
          }
          else if (this.isObject) {
            this.chartTitle = (!!this.chartTitle) ? this.chartTitle : this.name + " - " + Object.keys(this.values)[0];
            this.chartData = (!!this.chartData && this.chartData.length > 0) ? this.chartData : this.values[Object.keys(this.values)[0]];
            return this.nestedBarChartOptions;
          }
          else if (this.xlabeltype && this.xlabeltype === "date") return this.barChartOptions;
          else if (this.values.length > 2) return this.barChartOptions;
          else if (this.values.length == 1) return this.barChartOptions;
          console.log("Checker: ", this.values);
          return this.pieChartOptions;
        }
      },

      nestedBarChartOptions() {
        let categories = this.chartData.map(bin => bin[0]);
        let chart = this.isString || this.isObject ? 'bar' : 'column';
        this.chartType = (!!this.chartType) ? this.chartType : chart;
        return {
          chart: {
            type: this.chartType
          },
          title: {
            text: titleCase(this.chartTitle)
          },
          xAxis: {
            categories: categories,
            crosshair: true
          },
          yAxis: {
            min: 0,
            title: {
              text: this.title
            }
          },
          tooltip: {
            headerFormat: '',
            pointFormat: '<b>{point.y}</b>',
            footerFormat: '',
            shared: true,
            useHTML: true
          },
          plotOptions: {
            column: {
              pointPadding: 0.2,
              borderWidth: 0
            }
          },
          series: [{
            showInLegend: false,
            name: titleCase(this.name),
            data: this.chartData.map(point => point[1])
          }],
          exporting: this.exportOptions
        };
      },

      stackedBarChartOptions() {
        let series = [];
        let xKeys = [];
        let xLabels = [];
        let xValues = {};
        let notSet = 0;
        // this.values.map(bin => bin[0]).forEach(element => {console.log(Object.keys(element));})
        this.values.forEach(element => {
          let count = element[1];
          if (this.checkIfObject(element[0]) && element[0] != {}) {
            Object.keys(element[0]).forEach(e => {
              if (xKeys.indexOf(e) < 0) {
                xKeys.push(e);
              }
              // console.log(e, xValues, xValues[e]);
              if (!!xValues[e]) {
                console.log(element[0][e], xValues[e]);
                if (xLabels.indexOf(element[0][e]) < 0) xLabels.push(element[0][e]);
                if (element[0][e] in xValues[e]) {
                  xValues[e][element[0][e]] += count;
                } else {
                  xValues[e][element[0][e]] = count;
                }
              } else {
                xValues[e] = {};
                xValues[e][element[0][e]] = count;
              }
            });
          }
          // console.log(element[0]);
          count = 0;
        });

        // xLabels.push("not set");
        xLabels.forEach(x => {
          let data = [];
          if (x !== 'not set') {
            data = Object.values(xValues).map(a => a[x]);
          } else {
            for (let i=0; i<Object.values(xValues).length; i++) {
              data.push(notSet);
            }
          }
          var newData = [];
          data.forEach(x => {
            newData.push((!!x) ? x : null);
          });
          series.push({"name": x, "data": newData});
        });
        console.log("Labels: ", xLabels, series);
        this.chartType = (!!this.chartType) ? this.chartType : 'bar';
        return {
          chart: {
            type: this.chartType
          },
          title: {
            text: titleCase(this.name)
          },
          xAxis: {
            categories: xKeys,
            crosshair: true
          },
          yAxis: {
            min: 0,
            title: {
              text: this.title
            }
          },
          plotOptions: {
            series: {
              stacking: 'normal'
            }
          },
          series: series,
          exporting: this.exportOptions
        };
      },

      barChartOptions() {
        let categories = this.values.map(bin => bin[0]);
        console.log("values", this.values)
        console.log("categories", categories)
         let chart = (this.isString || typeof categories[0] === 'string') ? 'bar' : 'column';
        if (this.defaultChart === "column") {
          chart = this.defaultChart
        }

        this.chartType = (!!this.chartType) ? this.chartType : chart;
        return {
          chart: {
            type: this.chartType
          },
          title: {
            text: titleCase(this.title)
          },
          xAxis: {
            categories: categories,
            crosshair: true,
            title: {
              text: `${!!this.xlabel ? this.xlabel : lowerCase(this.name)}`
            }
          },
          yAxis: {
            min: 0,
            title: {
              text: `${!!this.ylabel ? this.ylabel : ''}`
            }
          },
          tooltip: {
            headerFormat: '',
            pointFormat: '<b>{point.y}</b>',
            footerFormat: '',
            shared: true,
            useHTML: true
          },
          plotOptions: {
            column: {
              pointPadding: 0.2,
              borderWidth: 0,
              dataLabels: {
                enabled: true
              }
            },
            bar: {
              useHTML: true,
              pointPadding: 0.2,
              borderWidth: 0,
              dataLabels: {
                enabled: true
              },
              format: '<span style="font-size: 10px">{point.value}</span>'
            },
            pie: {
              showInLegend: true,
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                formatter: function() {
                  var sliceIndex = this.point.index;
                  var sliceName = this.series.chart.axes[0].categories[sliceIndex];
                  return sliceName
                }
              }
            }
          },
          series: [{
            showInLegend: false,
            name: titleCase(this.name),
            data: this.values.map(point => point[1])
          }],
          exporting: {
            buttons: {
              contextButton: {
                menuItems: [
                  'printChart',
                  'separator',
                  'downloadPNG',
                  'downloadJPEG',
                  'downloadPDF',
                  'downloadSVG'
                ]
              }
            }
          }
        };
      },

      pieChartOptions() {
        this.chartType = (!!this.chartType) ? this.chartType : 'pie';
        return {
          chart: {
            type: this.chartType,
          },
          title: {
            text: titleCase(this.title)
          },
          tooltip: {
            pointFormat: '<p>Count: <b>{point.y}</b><br/>Percentage: <b>{point.percentage:.1f}%</b></p>'
          },
          plotOptions: {
            bar: {
              dataLabels: {
                enabled: true
              }
            },
            pie: {
              showInLegend: true,
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                formatter: function() {
                  var sliceIndex = this.point.index;
                  var sliceName = this.series.chart.axes[0].categories[sliceIndex];
                  return sliceName
                }
              }
            }
          },
          legend: {
            itemDistance: 5,
            itemStyle: {
              fontSize: '11px'
            }
          },
          series: [{
            name: titleCase(this.name),
            colorByPoint: true,
            data: this.values.map(point => ({
              name: maybeMissingValueLabel(point[0]),
              y: point[1]
            }))
          }]
        };
      },

      drillDownChartOptions() {
        let series = this.values;
        let seriesData = [];

        series.forEach(element => {
            let y = 0;
            element.data.forEach(d => {
              y += d[1]
            })
            seriesData.push({name: element.name, y: y, drilldown: element.name})
          }
        )
        let newSeries = {name: titleCase(this.name), data: seriesData};
        let chart = "column"
        this.chartType = (!!this.chartType) ? this.chartType : chart;
        return {
          chart: {
            type: this.chartType
          },
          title: {
            text: titleCase(this.title)
          },
          subtitle: {
            text: `${this.subtitle}`
          },
          accessibility: {
            announceNewData: {
              enabled: true
            }
          },
          xAxis: {
            type: 'category',
            title: {
              text: `${this.xlabel}`
            }
          },
          yAxis: {
            title: {
              text: `${this.ylabel}`
            }
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: '{point.y}'
              }
            }
          },
          tooltip: {
            headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
            pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b><br/>'
          },
          series: [newSeries],
          exporting: this.exportOptions,
          drilldown: {
            series: series
          }
        };
      },
    }
  };
</script>

<style scoped lang="css">
  /deep/ .modal-dialog {
    max-width: 100% !important; 
    margin-top: 0 !important; 
    margin: 0 !important; 
    top: 0 !important; 
    bottom: 0 !important; 
    left: 0 !important; 
    right: 0 !important; 
    height: 100vh !important; 
    max-height: 150vh !important; 
    display: flex !important; 
    position: relative !important; 
    z-index: 100000 !important
  }

  @media (min-width: 1200px) {
    .modal-xl {
      max-width: auto !important;
    }
  }

  @media (min-height: 600px) {
    .modal-xl {
      max-height: 80% !important;
    }
  }

  @media (min-width: 992px) {
    .modal-lg, .modal-xl {
      max-width: auto !important;
    }
  }

  @media (min-width: 992px) {
    .modal-dialog {
      max-width: auto !important;
    }
  }

  .card-style {
    margin: 0
  }

  .card-header-padding {
    padding: 0
  }

  .insight-cols-1 {
    width: 25%; 
    max-width: 100%; 
    z-index: 0
  }
  .insight-cols-2 {
    width: 50%; 
    max-width: 100%; 
    z-index: 0
  }
  .insight-cols-3 {
    width: 75%; 
    max-width: 100%; 
    z-index: 0
  }
  .insight-cols-4 {
    width: 100%; 
    max-width: 100%; 
    z-index: 0
  }

  @media (max-width: 480px) {
    .insight-cols-1 {
      width: 100%; 
      z-index: 0
    }
    .insight-cols-2 {
      width: 100%; 
      z-index: 0
    }
    .insight-cols-3 {
      width: 150%; 
      z-index: 0
    }
    .insight-cols-4 {
      width: 200%; 
      z-index: 0
    }
  }

  @media (max-width: 320px) {
    .insight-cols-1, .insight-cols-2, .insight-cols-3, .insight-cols-4 {
      width: 100%; 
      z-index: 0
    }
  }

</style>
